import React from 'react';
import Assets from 'app/configs/assetConfigs'
import { makeStyles } from '@material-ui/core/styles';

const useStyles=makeStyles(theme=>{
    return {
        logo:{
           width:'400px',
           '@media(max-width:406px)':{
               width:'95vw',
               marginLeft:'7px'
           }
        }
    }
})

function FuseSplashScreen()
{
    const classes=useStyles()
    return (
        <div id="fuse-splash-screen">

            <div className="center">

                <div className="logo">
                    <img
                        className={classes.logo}
                        src={Assets.bannerRev}
                        alt="logo"
                    />
                </div>
                <div className="spinner-wrapper">
                    <div className="spinner">
                        <div className="inner">
                            <div className="gap"/>
                            <div className="left">
                                <div className="half-circle"/>
                            </div>
                            <div className="right">
                                <div className="half-circle"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default React.memo(FuseSplashScreen);
